'use client'

import { RichText } from '@/components/shared/rich-text'
import { Button } from '@/components/ui/button'
import { fadeInBlur } from '@/lib/animations'
import { MainHeroStoryblok } from '@/lib/types/component-types-sb'
import { storyblokEditable } from '@storyblok/react/rsc'
import { ChevronRight } from 'lucide-react'
import { motion } from 'motion/react'
import { StoryblokImage } from '../shared/storyblok-image'
import { StoryblokLink } from '../shared/storyblok-link'
export function MainHero({ blok }: { blok: MainHeroStoryblok }) {
  const firstButton = blok.buttons?.at(0)
  const secondButton = blok.buttons?.at(1)

  return (
    <section
      {...storyblokEditable(blok)}
      className="overflow-hidden py-12 lg:pt-30 lg:pb-6"
    >
      <div className="page-container">
        <div className="relative z-10">
          <motion.h1
            {...fadeInBlur}
            transition={{ duration: 0.7 }}
            className="text-accent-foreground tracking-hero-title mb-3 text-4xl leading-none font-semibold lg:max-w-[60%] lg:text-6xl"
          >
            {blok.title}
          </motion.h1>
          <motion.div
            {...fadeInBlur}
            transition={{ delay: 0.3, duration: 0.7 }}
            className="mb-9 text-lg lg:max-w-1/2"
          >
            <RichText content={blok.content} />
          </motion.div>
          <motion.div
            {...fadeInBlur}
            transition={{ delay: 0.5, duration: 0.5 }}
            className="flex items-center gap-2"
          >
            {firstButton?.target && (
              <Button
                asChild
                key={firstButton._uid}
              >
                <StoryblokLink link={firstButton.target}>{firstButton.label}</StoryblokLink>
              </Button>
            )}
            {secondButton?.target && (
              <Button
                asChild
                key={secondButton._uid}
                className="hover:bg-accent hover:text-accent-foreground from-accent-foreground to-muted-foreground bg-gradient-to-r bg-clip-text text-transparent"
              >
                <StoryblokLink link={secondButton.target}>
                  {secondButton.label}
                  <ChevronRight className="text-foreground" />
                </StoryblokLink>
              </Button>
            )}
          </motion.div>
        </div>
        {blok.visual && (
          <div className="-mx-8 flex justify-center lg:mx-0 lg:-translate-y-20">
            <StoryblokImage
              image={blok.visual}
              cropWidth={1600}
              priority
              className="h-auto w-[600px] max-w-[600px] lg:w-full lg:max-w-full 2xl:w-3/4"
            />
          </div>
        )}
      </div>
    </section>
  )
}
